import React from "react";
import PropTypes from "prop-types";
import { PoweredByQgiv, Icon, DigiCert } from "@qgiv/core-react";
import "./RegistrationFooter.scss";

const RegistrationFooter = ({ securityLabel }) => (
    // Move the Powered by Qgiv logo to the left of the other 2 icons on xl devices
    <div className="registration-footer grid">
        <div className="col col--10 col--xl-6 col--xl-order-2 registration-footer__col registration-footer__security-label">
            <div>
                <Icon
                    className="registration-footer__icon"
                    glyph="lock-alt-solid"
                    type="FontAwesome"
                />
                <span>
                    <small>{securityLabel}</small>
                </span>
            </div>
        </div>
        <div className="col col--2 col--xl-2 col--xl-order-3 registration-footer__col registration-footer__digicert">
            <DigiCert />
        </div>
        <div className="col col--12 col--xl-4 col--xl-order-1 registration-footer__col registration-footer__powered-by-qgiv">
            <PoweredByQgiv dark classNames={["-margin--0"]} />
        </div>
    </div>
);
RegistrationFooter.propTypes = {
    securityLabel: PropTypes.string.isRequired,
};

export default RegistrationFooter;
